/**
 * Lightweight CSS-only floating particles — no framer-motion overhead.
 * Uses pure CSS keyframes for 6 particles instead of 20 JS-animated ones.
 */
const FloatingParticles = () => (
  <div className="absolute inset-0 overflow-hidden pointer-events-none">
    {[...Array(6)].map((_, i) => (
      <span
        key={i}
        className="absolute rounded-full bg-white/20 animate-float-particle"
        style={{
          left: `${15 + i * 15}%`,
          top: `${20 + (i % 3) * 25}%`,
          width: `${3 + (i % 3)}px`,
          height: `${3 + (i % 3)}px`,
          animationDelay: `${i * 0.8}s`,
          animationDuration: `${8 + i * 2}s`,
        }}
      />
    ))}
  </div>
);

export default FloatingParticles;
